import React, { ChangeEvent, useContext, useState } from "react";
import { dashboardContext, Access } from "../Dashboard";
import { useMutation, useQuery } from "@apollo/client";
import {
  GET_MERCHANT_PAYMENT_FORMS,
  UPLOAD_STUDENTS_CSV,
} from "../../../Qurries";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import {
  Table,
  Pagination,
  RowsPerPageSelect,
} from "../../../components/Table";
import Modal from "../../../components/Modal/Modal";
import CreateForm from "./CreateForm";
import { IoSearchOutline } from "react-icons/io5";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import Select from "react-select";
import { CustomDropdownIndicator } from "../Settlement/Settlement";
import { HiMiniXMark } from "react-icons/hi2";
import { MdContentCopy } from "react-icons/md";
import ToolTip from "../components/ToolTip";
import { toast } from "react-toastify";
import { Form, Input } from "edviron-ui-package";
// @ts-ignore
import studentsSample from "../../../assets/sample__students.csv";
import { FaEdit } from "react-icons/fa";

interface StudentUploadCSVUpdateProps {
  schoolId: string | null;
  schoolName?: string | null;
  formId: string | null;
  setShowEditModal: (value: boolean) => void;
}

export const StudentUploadCSVUpdate: React.FC<StudentUploadCSVUpdateProps> = ({
  schoolId,
  formId,
  setShowEditModal,
}) => {
  const [fileName, setFileName] = useState<string>("");
  const [base64, setBase64] = useState<string>("");
  const [isUploading, setIsUploading] = useState(false);
  const [isButtonActive, setIsButtonActive] = useState<boolean>(false);

  const [uploadStudentsExcelMerchant, { loading: uploadLoading }] = useMutation(
    UPLOAD_STUDENTS_CSV,
    {
      onCompleted: (data) => {
        toast.success(
          data?.uploadStudentsExcelMerchant || "Students uploaded successfully",
        );
        setFileName("");
        setBase64("");
        setIsButtonActive(false);
        setIsUploading(false);
        setShowEditModal(false);
      },
      onError: (error) => {
        toast.error(error?.message || "Error uploading students");
        setIsUploading(false);
      },
    },
  );

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    if (!file.name.endsWith(".csv")) {
      toast.error("Please select a CSV file");
      return;
    }

    setFileName(file.name);
    setIsButtonActive(true);

    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      setBase64(result);
    };
    reader.readAsDataURL(file);
  };

  const downloadSampleCSV = () => {
    const link = document.createElement("a");
    link.setAttribute("href", studentsSample);
    link.setAttribute("download", "sample_students.csv");
    link.style.visibility = "hidden";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success("Sample CSV file downloaded successfully");
  };

  const handleUploadStudents = async () => {
    if (!base64) {
      toast.warning("Please select a CSV file");
      return;
    }

    if (!schoolId) {
      toast.warning("Please select a school first");
      return;
    }

    setIsUploading(true);

    try {
      await uploadStudentsExcelMerchant({
        variables: {
          data: { file: base64, filename: fileName },
          school_id: schoolId,
          form_id: formId || "",
        },
      });
    } catch (error: any) {
      setIsUploading(false);
    }
  };

  if (!schoolId) {
    return null;
  }

  return (
    <div className="flex w-full">
      <div className="mx-auto w-full">
        <Form
          onSubmit={async (e: any) => {
            e.preventDefault();
            await handleUploadStudents();
          }}
          className=""
        >
          <Input
            add_error={() => {}}
            type="file"
            accept=".csv"
            name="Upload CSV File"
            onChange={(e: any, v: React.ChangeEvent<HTMLInputElement>) => {
              handleFileChange(v);
            }}
            label="CSV File"
          />
          <a
            className="text-sm ml-auto text-[#6687FF] cursor-pointer"
            onClick={downloadSampleCSV}
          >
            Download Sample File
          </a>

          <div className="bg-edviron_black m-2 mt-6 text-white rounded-lg font-medium py-2 px-5">
            <button
              type="button"
              className="w-full"
              onClick={handleUploadStudents}
              disabled={!isButtonActive || isUploading}
            >
              {isUploading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default function GetForm() {
  const { user, isRedirectedUser, tokenData } = useContext(dashboardContext);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [formData, setFormData] = useState<any>(null);
  const [searchFilter, setSearchFilter] = useState<any>("");
  const [searchText, setSearchText] = useState<string>("");
  const [itemsPerRow, setItemsPerRow] = useState<any>({
    name: 10,
  });
  const [currentPage, setCurrentPage] = useState<any>(1);
  const { data, loading, error, refetch } = useQuery(
    GET_MERCHANT_PAYMENT_FORMS,
    {
      variables: {
        page: currentPage,
        limit: itemsPerRow.name,
      },
    },
  );

  const handleCopyContent = (content: any) => {
    navigator.clipboard
      .writeText(content)
      .then(() => {
        toast.success("Copied to clipboard");
      })
      .catch((err) => {
        toast.error("Error while copying");
      });
  };

  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };

  return (
    <div className="p-4 w-full mt-4 text-left">
      <div className="flex-1 flex flex-col items-center">
        {loading && <p className="text-gray-500">Loading...</p>}
        {error && <p className="text-red-500">Error loading forms</p>}

        <Table
          className="bg-[#ffffff]"
          heading={"Payment Forms"}
          perPage={false}
          pagination={false}
          copyRight={false}
          searchBox={
            <div className="flex flex-col  gap-y-2 w-full">
              <div className="flex justify-between items-center">
                <div className="bg-[#EEF1F6] py-2 items-center flex  px-3 xl:max-w-md max-w-[34rem] w-full rounded-lg">
                  <input
                    className="text-xs pr-2 bg-transparent focus:outline-none w-full placeholder:font-normal"
                    type="text"
                    value={searchText}
                    placeholder="Search (Form ID...)"
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />
                  {searchFilter !== "" && searchText.length > 1 && (
                    <HiMiniXMark
                      onClick={async () => {
                        setSearchFilter("");
                        setSearchText("");
                        refetch({
                          page: currentPage,
                          limit: itemsPerRow.name,
                          school_id: undefined,
                          form_id: undefined,
                        });
                      }}
                      className="text-[#1E1B59] cursor-pointer text-md mr-2 shrink-0"
                    />
                  )}
                  <Select
                    className="border-l-2 border-gray-400"
                    options={[{ label: "By School ID", value: "school_id" }]}
                    isSearchable={false}
                    components={{
                      DropdownIndicator: CustomDropdownIndicator,
                      IndicatorSeparator: () => null,
                    }}
                    onChange={(e: any) => {
                      setSearchFilter(e.value.toLowerCase());
                      setCurrentPage(1);
                    }}
                    placeholder={
                      <div className="text-[#1E1B59] -mt-1 capitalize text-[10px]">
                        {searchFilter === ""
                          ? "filter by"
                          : searchFilter
                              .toString()
                              .toLowerCase()
                              .replaceAll("_", " ")}
                      </div>
                    }
                    value={searchFilter}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: "transparent",
                        height: "20px",
                        border: "none",
                        boxShadow: "none",
                        cursor: "pointer",
                        minHeight: "10px",
                        padding: "0px",
                      }),
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "20px",
                        width: "8rem",
                        padding: "0 8px",
                      }),
                      input: (provided) => ({
                        ...provided,
                        margin: "0",
                        padding: "0",
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        margin: "0",
                        padding: "0",
                        lineHeight: "20px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "20px",
                      }),
                      indicatorsContainer: (provided) => ({
                        ...provided,
                        height: "20px",
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        fontSize: "10px",
                        cursor: "pointer",
                      }),
                    }}
                  />

                  <div className="w-10 z-50 shrink-0 flex justify-center items-center">
                    {searchText.length > 1 && loading ? (
                      <AiOutlineLoading3Quarters className="text-xs animate-spin" />
                    ) : (
                      <IoSearchOutline
                        onClick={() => {
                          refetch({
                            page: currentPage,
                            limit: itemsPerRow.name,
                            school_id:
                              searchFilter === "school_id"
                                ? searchText
                                : undefined,
                            form_id:
                              searchFilter === "form_id"
                                ? searchText
                                : undefined,
                          });
                        }}
                        className=" cursor-pointer text-edvion_black text-opacity-50 text-md "
                      />
                    )}
                  </div>
                </div>
                {((isRedirectedUser ? tokenData?.role : user?.getMerchantQuery?.role) === Access.OWNER || (isRedirectedUser ? tokenData?.role : user?.getMerchantQuery?.role) === Access.ADMIN) && (
                  <div className="flex ml-auto">
                    <button
                      onClick={() => setShowModal(!showModal)}
                      className="py-2 bg-edviron_black text-sm rounded-[4px] text-white float-right px-6 ml-2"
                    >
                      Create Payment Form
                    </button>
                  </div>
                )}
              </div>
              <div>
                <RowsPerPageSelect
                  setItemsPerRow={(e: any) => {
                    setCurrentPage(1);
                    setItemsPerRow(e);
                  }}
                  itemsPerRow={itemsPerRow}
                  className=" justify-start"
                />
              </div>
            </div>
          }
          data={[
            [
              "S. No.",
              "Heading",
              "Vendor ID",
              "Split Payment",
              "Amount",
              "Type",
              "Edit Form",
              "Form Link",
            ],
            ...(data?.getMerchantPaymentFormData?.data?.map(
              (form: any, index: number) => [
                (currentPage - 1) * itemsPerRow.name + 1 + index,
                <div className="flex justify-between items-center gap-2">
                  <div className="truncate" title={form?.heading}>
                    {form?.heading || "N/A"}
                  </div>
                  <button
                    onClick={() => {
                      handleCopyContent(form?.heading);
                    }}
                  >
                    <ToolTip text="Heading">
                      <MdContentCopy
                        className="cursor-pointer text-[#717171] shrink-0 text-xl"
                        style={{
                          fontSize: "22px",
                          color: "",
                          backgroundColor: "transparent",
                        }}
                      />
                    </ToolTip>
                  </button>
                </div>,

                <div className="flex justify-between items-center gap-2">
                  <div
                    className="truncate"
                    title={form?.vendor_info?.[0]?.vendor_id || "N/A"}
                  >
                    {form?.vendor_info?.[0]?.vendor_id || "N/A"}
                  </div>
                  <button
                    onClick={() => {
                      handleCopyContent(form?.vendors_info?.vendor_id);
                    }}
                  >
                    <ToolTip text="Vendor ID">
                      <MdContentCopy
                        className="cursor-pointer text-[#717171] shrink-0 text-xl"
                        style={{
                          fontSize: "22px",
                          color: "",
                          backgroundColor: "transparent",
                        }}
                      />
                    </ToolTip>
                  </button>
                </div>,
                form.split_payments ? "Yes" : "No",

                form.amount ? `₹${form.amount}` : "N/A",
                form.amount_type || "N/A",
                ((isRedirectedUser ? tokenData?.role : user?.getMerchantQuery?.role) === Access.OWNER || (isRedirectedUser ? tokenData?.role : user?.getMerchantQuery?.role) === Access.ADMIN) ? (
                  <button
                    onClick={() => {
                      setFormData(form);
                      setShowEditModal(true);
                    }}
                  >
                    <FaEdit />
                  </button>
                ) : (
                  "-"
                ),
                form.form_link ? (
                  <a
                    href={form.form_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:text-blue-700"
                  >
                    <FaArrowUpRightFromSquare />
                  </a>
                ) : (
                  "N/A"
                ),
              ],
            ) || []),
          ]}
          footer={
            <div className="flex justify-center items-center">
              <Pagination
                currentPage={currentPage}
                totalPages={Math.ceil(data?.getpaymentFormData?.totalPages)}
                onPageChange={handlePageChange}
              />
            </div>
          }
        />
      </div>

      <Modal
        className="max-w-lg w-full"
        open={showModal}
        setOpen={(value: boolean) => {
          setShowModal(value);
          if (!value) refetch();
        }}
        title="Create Payment Form"
      >
        <CreateForm />
      </Modal>
      <Modal
        className="max-w-lg w-full"
        open={showEditModal}
        setOpen={(value: boolean) => {
          setShowEditModal(value);
        }}
        title="Update Payment Form"
      >
        <StudentUploadCSVUpdate
          schoolId={formData?.school_id}
          formId={formData?._id}
          setShowEditModal={setShowEditModal}
        />
      </Modal>
    </div>
  );
}
